export default "__VITE_PUBLIC_ASSET__cf83f91f__"